<div mat-dialog-title class="dialog-title" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle
  style="display: flex; justify-content: space-between; align-items: center;">
  <span>{{label()}}</span>
  <button (click)="doOk($event)">
    離開
  </button>
</div>
<div class="file-manager-container">
  <div class="toolbar">
    <div class="path-navigation">
      <button (click)="navigateUp()" [disabled]="pathDisabled">
        <span>↑ 上一層</span>
      </button>
      <app-jktext label="當前路徑" [value]="currentDirectory">
      </app-jktext>
      <app-jktext label="主機" [value]="uploadHost+uploadBaseUrl">
      </app-jktext>
    </div>

    <div class="actions">
      <input #imageInput type="file" accept="image/*" style="display:none"
        (change)="onImageFileSelected($event)">
      <button type="button" mat-stroked-button color="primary" (click)="imageInput.click()">
        <span>上傳圖片</span>
      </button>

      <button (click)="showNewFolderDialog = true" [disabled]="pathDisabled">
        <span>新增資料夾</span>
      </button>

      <label class="upload-button">
        <span>上傳檔案</span>
        <input type="file" [multiple]="multiple" (change)="onFileSelected($event)" style="display: none;">
      </label>

      <button (click)="deleteSelectedItems()" [disabled]="selectedItems.length === 0">
        <span>刪除已選檔案</span>
      </button>
      <a #downloadLink id="downloadLink" style="display: none;" [href]="downloadUrl" download>下載點</a>
    </div>
  </div>

  <!-- 新增資料夾對話框 -->
  @if (showNewFolderDialog) {
  <div class="dialog-overlay">
    <div class="dialog">
      <h3>新增資料夾</h3>
      <div class="dialog-content">
        <input type="text" [(ngModel)]="newFolderName" placeholder="請輸入資料夾名稱">
      </div>
      <div class="dialog-actions">
        <button (click)="showNewFolderDialog = false">取消</button>
        <button (click)="createFolder()" type="submit" autofocus>確定</button>
      </div>
    </div>
  </div>
  }

  <!-- 檔案拖放區域 -->
  <div class="drop-zone" [class.drag-over]="dragOver" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    @if(fileList.length === 0 && !isLoading) {
    <div class="drop-message">
      <p>{{ labelText }}</p>
    </div>
    }

    <!-- 載入中指示器 -->
    @if (isLoading) {
    <div class="loading">
      <p>載入中...</p>
    </div>
    }

    <!-- 檔案列表 -->
    @if (!isLoading) {
    <table class="file-list">
      <thead>
        <tr>
          <th style="width: 30px;"></th>
          <th>動作</th>
          <th>名稱</th>
          <th>類型</th>
          <th>大小</th>
          <th>修改日期</th>
        </tr>
      </thead>
      <tbody>
        @for (item of fileList; track item.path) {
        <tr [class.selected]="isSelected(item)" (click)="navigateToFolder(item)">
          <td>
            <input type="checkbox" [checked]="isSelected(item)" (click)="toggleSelection(item, $event)">
          </td>
          <td>
            <button mat-raised-button (click)="downloadFile(item)">
              <span>下載</span>
            </button>

          </td>
          <td>
            @if (item.type === 'folder') {
            <span class="folder-icon">📁</span>
            } @else {
            <span class="file-icon">📄</span>
            }
            {{ item.name }}
          </td>
          <td>{{ item.type === 'folder' ? '資料夾' : '檔案' }}</td>
          <td>{{ item.type === 'folder' ? '-' : formatFileSize(item.size) }}</td>
          <td>{{ formatDate(item.modified) }}</td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>
</div>

<style>
  .file-manager-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
  }

  .toolbar {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
  }

  .path-navigation {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .current-path {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .actions {
    display: flex;
    gap: 10px;
  }

  button,
  .upload-button {
    padding: 6px 12px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  button:hover,
  .upload-button:hover {
    background-color: #f0f0f0;
  }

  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .drop-zone {
    flex: 1;
    padding: 20px;
    overflow: auto;
    position: relative;
    min-height: 300px;
  }

  .drag-over {
    background-color: rgba(0, 120, 215, 0.1);
    border: 2px dashed #0078d7;
  }

  .drop-message {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #666;
    text-align: center;
  }

  .file-list {
    width: 100%;
    border-collapse: collapse;
  }

  .file-list th,
  .file-list td {
    padding: 8px 12px;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  .file-list th {
    background-color: #f5f5f5;
    font-weight: bold;
  }

  .file-list tr:hover {
    background-color: #f9f9f9;
  }

  .file-list tr.selected {
    background-color: #e6f7ff;
  }

  .folder-icon,
  .file-icon {
    margin-right: 8px;
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .dialog {
    background-color: white;
    border-radius: 4px;
    padding: 20px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }

  .dialog h3 {
    margin-top: 0;
    margin-bottom: 16px;
  }

  .dialog-content {
    margin-bottom: 16px;
  }

  .dialog-content input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
</style>
